import {FARMER_SITE_URL} from 'constants/index';

export const _GetInviteUrlRoot = (forDisplay?: boolean) =>
  `${FARMER_SITE_URL}/sdinvite`.replace(forDisplay ? 'https://' : '', '');
